import { FlightEventHandler } from './flight'
import { writable } from 'svelte/store'
import { tick } from 'svelte'

const DRONE_MAX_SEEN = 10 * 1000 // 10s in millis
const CLEANUP_TIMEOUT = 5000

export default class PerceptoHits extends FlightEventHandler {
	constructor(flight) {
		super(flight)

		const { subscribe, set, update } = writable({});
		this.subscribe = subscribe
		this.set = set
		this.update = update

		this.drones = {}

		this.cleanup()
	}

	async handleKeyframe(keyframe) {
		this.set({})
		await tick()
		this.set(keyframe.perceptoTracks ?? {})
	}

	handleFlightStep(message) {
		if (!message.type.startsWith('PERCEPTO')) return
		this.update(allHits => {
			let hits = allHits[message.droneId]
			if (!hits) {
				hits = []
				allHits[message.droneId] = hits
			}
			this.drones[message.droneId] = Date.now()
			hits.push(message)

			return allHits
		})
	}

	cleanup() {
		const now = Date.now()
		const needsClear = []
		for (const [droneId, timeout] of Object.entries(this.drones)) {
			if (timeout < now - DRONE_MAX_SEEN) needsClear.push(droneId)
		}

		if (needsClear.length) {
			this.update(allHits => {
				for (const droneId of needsClear) {
					delete allHits[droneId]
					delete this.drones[droneId]
				}
				return allHits
			})
		}

		setTimeout(() => this.cleanup(), CLEANUP_TIMEOUT)
	}
}